import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { IDataProviderFilter, IFilter, Logic, Operator } from 'core-components/types/ICrudHelpers'
import { CrudStore } from 'core/types/crudStore'

import { IContact } from '../model/types'

import { mapContactFromContactAllData } from './mapping/mapContactFromContactAllData'

interface IFetchContactsWithSameRole {
  role: string
  contactId: string
  partnerId: string
  isFilterByPartnerId: boolean
}

export const fetchContactsWithSameRole = async ({
  role,
  contactId,
  partnerId,
  isFilterByPartnerId,
}: IFetchContactsWithSameRole) => {
  const crud = CrudStore.get(CrudStoreItem.ContactAllData, contactId)

  const filterByRole: IDataProviderFilter = {
    logic: Logic.OR,
    filters: [
      {
        field: 'PR_HP_ROLE',
        operator: Operator.CONTAINS,
        value: role,
      },
      {
        field: 'PR_HP_ROLEExt',
        operator: Operator.CONTAINS,
        value: role,
      },
    ],
  }

  const defaultFilters: Array<IFilter | IDataProviderFilter> = [
    {
      field: 'TopPartnerID',
      operator: Operator.EQUAL,
      value: partnerId,
    },
    {
      logic: Logic.OR,
      filters: [
        {
          field: 'HierarchyType',
          operator: Operator.EQUAL,
          value: 'Headquarters',
        },
        {
          field: 'HierarchyType',
          operator: Operator.EQUAL,
          value: 'Branch',
        },
      ],
    },
    {
      field: 'ContactID',
      operator: Operator.NOTEQUAL,
      value: contactId,
    },
    filterByRole,
  ]

  const subsidiaryOrAffiliateFilters: Array<IFilter | IDataProviderFilter> = [
    {
      field: 'PartnerID',
      operator: Operator.EQUAL,
      value: partnerId,
    },
    {
      field: 'ContactID',
      operator: Operator.NOTEQUAL,
      value: contactId,
    },
    filterByRole,
  ]

  const filters: IDataProviderFilter = {
    logic: Logic.AND,
    filters: isFilterByPartnerId ? subsidiaryOrAffiliateFilters : defaultFilters,
  }

  crud.setFilter(filters)
  crud.setPaging({
    page: 0,
    pageSize: 100,
  })

  return crud.fetch().then((result): IContact[] => {
    if (result && result.items) {
      return result.items.map(mapContactFromContactAllData)
    }

    return []
  })
}
